module.exports = __webpack_public_path__ + "bc7fe62ab18280df649a8fa8def64c0c.pdf";